import React from 'react'
import { observer, inject } from 'mobx-react'

import storage, { purgeAllAutoSave } from '@client/utils/Storage'

import './styles.scss'

export const StorageQuotaWarning = ({ app }) => {
  const show = storage.disabled

  return (
    <div className={`storage-quota-warning${show ? ' show' : ''}`}>
      <div>
        <span className="storage-quota-warning--message">
          {app.formatMessage('storageQuota.message')}
        </span>
      </div>
      <div>
        <button
          type="button"
          onClick={purgeAllAutoSave}
          className="storage-quota-warning--btn bp6-button bp6-intent-warning bp6-icon-trash"
        >
          {app.formatMessage('storageQuota.action')}
        </button>
      </div>
    </div>
  )
}

export default inject('app')(observer(StorageQuotaWarning))
